
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexWE9VGsrxuYqJj36Bd5Xuu0bDeCuF6SVcKiHgm5hliCAMeta } from "/var/www/scan.ova-restaurant.com/pages/index.vue?macro=true";
import { default as indexj8icSA9pIh2zm_45IkS_45R6I9dfyAE3XM9CdEMrce_bODgMeta } from "/var/www/scan.ova-restaurant.com/pages/[id]/index.vue?macro=true";
import { default as indexQ2wX_5C25tK5Tgu0EcTywaZPZbWUxwMjelj5w4zl2T4Meta } from "/var/www/scan.ova-restaurant.com/pages/cart/index.vue?macro=true";
import { default as indexZYdkIXAzManIbZqTrxbLoGWN8aWviTq3x6kkAnd7aNMMeta } from "/var/www/scan.ova-restaurant.com/pages/help/index.vue?macro=true";
import { default as indexOx9mjkAD9aWTgi5RJdVZ1VwPOgLVVbyny8MuY5v_45TF0Meta } from "/var/www/scan.ova-restaurant.com/pages/info/index.vue?macro=true";
import { default as index1BbwrfYJpeaDxfLUBoLSDZ_dyt58HHqRuoR83sh_45euoMeta } from "/var/www/scan.ova-restaurant.com/pages/menus/index.vue?macro=true";
import { default as indexF1zOZ5FEaABx_45CstNtEupCVJ6N_45Wn_45Z3uOOtxX_UF7AMeta } from "/var/www/scan.ova-restaurant.com/pages/orders/index.vue?macro=true";
import { default as indexIcioGWEAhTVUvQRFwfq8X_amA076NpV1kkdO7b7yhQoMeta } from "/var/www/scan.ova-restaurant.com/pages/tables/index.vue?macro=true";
import { default as terms_45of_45usedmALnQixrXkhNbqPt_k7paFNEnrTPh_B5o7DubA1z_sMeta } from "/var/www/scan.ova-restaurant.com/pages/terms-of-use.vue?macro=true";
import { default as index_k9hujEo9P1T5Ecs4GBcceSaxluNjLFla9qHmu16Zw8Meta } from "/var/www/scan.ova-restaurant.com/pages/confirm/index.vue?macro=true";
import { default as indexAVWWiV14RL8YA02p1P_n1nysUQyUVHqa28gXjwZDz0sMeta } from "/var/www/scan.ova-restaurant.com/pages/expired/index.vue?macro=true";
import { default as indexsTP2Bi4MrqqzSIKZ9Y8HEDUmKhIiA4STu2cMACVh6wcMeta } from "/var/www/scan.ova-restaurant.com/pages/profile/index.vue?macro=true";
import { default as indexCQHIFthsxycPFgf6VzmMmZy6g4Vw7UqdnvLM6lY9JZgMeta } from "/var/www/scan.ova-restaurant.com/pages/sign-in/index.vue?macro=true";
import { default as indexswvYAj0gJXVXsqOU8_ryPrt_45i9q5gCLD3RSC6kygBeUMeta } from "/var/www/scan.ova-restaurant.com/pages/sign-up/index.vue?macro=true";
import { default as index5cAkPUKviNetnO1W77IuRUJbWw0MqPnya_3hwyMOj_kMeta } from "/var/www/scan.ova-restaurant.com/pages/[...all]/index.vue?macro=true";
import { default as indexfhBrmgc_457kUQOUHcKU433vvNBj_QLCbcutWLglHfJR4Meta } from "/var/www/scan.ova-restaurant.com/pages/branches/index.vue?macro=true";
import { default as indexLXeWJC_45Xvm3Za_45K_ykRzqYBMjwWYbRjDurj441Aw0QkMeta } from "/var/www/scan.ova-restaurant.com/pages/checkout/index.vue?macro=true";
import { default as indexwBfEqSnkb_45ZfnKSgUQehtqr6dyDwEoZ2k0fCxXdJb_45gMeta } from "/var/www/scan.ova-restaurant.com/pages/delivery/index.vue?macro=true";
import { default as privacy_45policyWYqhD0r_OD0Ercomm6cOaD1mZvk7LBDELdao3aXrABgMeta } from "/var/www/scan.ova-restaurant.com/pages/privacy-policy.vue?macro=true";
import { default as indexnKnIx_45WTBhAmzjtvtK2UpPvPLyzk27B8liQtcF11yMAMeta } from "/var/www/scan.ova-restaurant.com/pages/categories/index.vue?macro=true";
import { default as index3Ep7_bll__1rQQ9M0cmDm84zPCQys_45L_BoX6avcVhdUMeta } from "/var/www/scan.ova-restaurant.com/pages/fulfillment/index.vue?macro=true";
import { default as indexbCXVQargF441shlLT1TBS0hyGMDXlk0d1GGFz4oleMAMeta } from "/var/www/scan.ova-restaurant.com/pages/privacy-legal/index.vue?macro=true";
import { default as indexEOKW8UP9F1dM2hCZLrjI0aGH3qFr1XfhFVGZJBpCgWoMeta } from "/var/www/scan.ova-restaurant.com/pages/reset-password/index.vue?macro=true";
import { default as indexB1iRZZ9pxxdCzvKOPKkl_3c2pwiRzXQODnJ_8fSWHdcMeta } from "/var/www/scan.ova-restaurant.com/pages/orders/[orderId]/index.vue?macro=true";
import { default as indexNdNC_45Tuf_45GNYcupVb4o73P1CJOpy3ZZcGAvxNyOGKWsMeta } from "/var/www/scan.ova-restaurant.com/pages/categories/[slug]/index.vue?macro=true";
import { default as PaymentsFailedModalekJWIObDluAVD3Vo8CUB_eHoUbox9uvyqFYujWQspJEMeta } from "/var/www/scan.ova-restaurant.com/pages/checkout/PaymentsFailedModal.vue?macro=true";
import { default as PaymentsSuccessedModaltMaTHwvqwkXQESO5BGU_45aZ0_45fflU56pD663aLv8k5I0Meta } from "/var/www/scan.ova-restaurant.com/pages/checkout/PaymentsSuccessedModal.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/index.vue")
  },
  {
    name: "index___hy",
    path: "/hy",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/index.vue")
  },
  {
    name: "id___en",
    path: "/:id()",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/[id]/index.vue")
  },
  {
    name: "id___fr",
    path: "/fr/:id()",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/[id]/index.vue")
  },
  {
    name: "id___it",
    path: "/it/:id()",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/[id]/index.vue")
  },
  {
    name: "id___de",
    path: "/de/:id()",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/[id]/index.vue")
  },
  {
    name: "id___hy",
    path: "/hy/:id()",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/[id]/index.vue")
  },
  {
    name: "id___ru",
    path: "/ru/:id()",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/[id]/index.vue")
  },
  {
    name: "cart___en",
    path: "/cart",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/cart/index.vue")
  },
  {
    name: "cart___fr",
    path: "/fr/cart",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/cart/index.vue")
  },
  {
    name: "cart___it",
    path: "/it/cart",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/cart/index.vue")
  },
  {
    name: "cart___de",
    path: "/de/cart",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/cart/index.vue")
  },
  {
    name: "cart___hy",
    path: "/hy/cart",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/cart/index.vue")
  },
  {
    name: "cart___ru",
    path: "/ru/cart",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/cart/index.vue")
  },
  {
    name: "help___en",
    path: "/help",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/help/index.vue")
  },
  {
    name: "help___fr",
    path: "/fr/help",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/help/index.vue")
  },
  {
    name: "help___it",
    path: "/it/help",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/help/index.vue")
  },
  {
    name: "help___de",
    path: "/de/help",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/help/index.vue")
  },
  {
    name: "help___hy",
    path: "/hy/help",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/help/index.vue")
  },
  {
    name: "help___ru",
    path: "/ru/help",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/help/index.vue")
  },
  {
    name: "info___en",
    path: "/info",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/info/index.vue")
  },
  {
    name: "info___fr",
    path: "/fr/info",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/info/index.vue")
  },
  {
    name: "info___it",
    path: "/it/info",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/info/index.vue")
  },
  {
    name: "info___de",
    path: "/de/info",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/info/index.vue")
  },
  {
    name: "info___hy",
    path: "/hy/info",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/info/index.vue")
  },
  {
    name: "info___ru",
    path: "/ru/info",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/info/index.vue")
  },
  {
    name: "menus___en",
    path: "/menus",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/menus/index.vue")
  },
  {
    name: "menus___fr",
    path: "/fr/menus",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/menus/index.vue")
  },
  {
    name: "menus___it",
    path: "/it/menus",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/menus/index.vue")
  },
  {
    name: "menus___de",
    path: "/de/menus",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/menus/index.vue")
  },
  {
    name: "menus___hy",
    path: "/hy/menus",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/menus/index.vue")
  },
  {
    name: "menus___ru",
    path: "/ru/menus",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/menus/index.vue")
  },
  {
    name: "orders___en",
    path: "/orders",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/orders/index.vue")
  },
  {
    name: "orders___fr",
    path: "/fr/orders",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/orders/index.vue")
  },
  {
    name: "orders___it",
    path: "/it/orders",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/orders/index.vue")
  },
  {
    name: "orders___de",
    path: "/de/orders",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/orders/index.vue")
  },
  {
    name: "orders___hy",
    path: "/hy/orders",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/orders/index.vue")
  },
  {
    name: "orders___ru",
    path: "/ru/orders",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/orders/index.vue")
  },
  {
    name: "tables___en",
    path: "/tables",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/tables/index.vue")
  },
  {
    name: "tables___fr",
    path: "/fr/tables",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/tables/index.vue")
  },
  {
    name: "tables___it",
    path: "/it/tables",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/tables/index.vue")
  },
  {
    name: "tables___de",
    path: "/de/tables",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/tables/index.vue")
  },
  {
    name: "tables___hy",
    path: "/hy/tables",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/tables/index.vue")
  },
  {
    name: "tables___ru",
    path: "/ru/tables",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/tables/index.vue")
  },
  {
    name: "terms-of-use___en",
    path: "/terms-of-use",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/terms-of-use.vue")
  },
  {
    name: "terms-of-use___fr",
    path: "/fr/terms-of-use",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/terms-of-use.vue")
  },
  {
    name: "terms-of-use___it",
    path: "/it/terms-of-use",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/terms-of-use.vue")
  },
  {
    name: "terms-of-use___de",
    path: "/de/terms-of-use",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/terms-of-use.vue")
  },
  {
    name: "terms-of-use___hy",
    path: "/hy/terms-of-use",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/terms-of-use.vue")
  },
  {
    name: "terms-of-use___ru",
    path: "/ru/terms-of-use",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/terms-of-use.vue")
  },
  {
    name: "confirm___en",
    path: "/confirm",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/confirm/index.vue")
  },
  {
    name: "confirm___fr",
    path: "/fr/confirm",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/confirm/index.vue")
  },
  {
    name: "confirm___it",
    path: "/it/confirm",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/confirm/index.vue")
  },
  {
    name: "confirm___de",
    path: "/de/confirm",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/confirm/index.vue")
  },
  {
    name: "confirm___hy",
    path: "/hy/confirm",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/confirm/index.vue")
  },
  {
    name: "confirm___ru",
    path: "/ru/confirm",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/confirm/index.vue")
  },
  {
    name: "expired___en",
    path: "/expired",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/expired/index.vue")
  },
  {
    name: "expired___fr",
    path: "/fr/expired",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/expired/index.vue")
  },
  {
    name: "expired___it",
    path: "/it/expired",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/expired/index.vue")
  },
  {
    name: "expired___de",
    path: "/de/expired",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/expired/index.vue")
  },
  {
    name: "expired___hy",
    path: "/hy/expired",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/expired/index.vue")
  },
  {
    name: "expired___ru",
    path: "/ru/expired",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/expired/index.vue")
  },
  {
    name: "profile___en",
    path: "/profile",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/profile/index.vue")
  },
  {
    name: "profile___fr",
    path: "/fr/profile",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/profile/index.vue")
  },
  {
    name: "profile___it",
    path: "/it/profile",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/profile/index.vue")
  },
  {
    name: "profile___de",
    path: "/de/profile",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/profile/index.vue")
  },
  {
    name: "profile___hy",
    path: "/hy/profile",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/profile/index.vue")
  },
  {
    name: "profile___ru",
    path: "/ru/profile",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/profile/index.vue")
  },
  {
    name: "sign-in___en",
    path: "/sign-in",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/sign-in/index.vue")
  },
  {
    name: "sign-in___fr",
    path: "/fr/sign-in",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/sign-in/index.vue")
  },
  {
    name: "sign-in___it",
    path: "/it/sign-in",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/sign-in/index.vue")
  },
  {
    name: "sign-in___de",
    path: "/de/sign-in",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/sign-in/index.vue")
  },
  {
    name: "sign-in___hy",
    path: "/hy/sign-in",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/sign-in/index.vue")
  },
  {
    name: "sign-in___ru",
    path: "/ru/sign-in",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/sign-in/index.vue")
  },
  {
    name: "sign-up___en",
    path: "/sign-up",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/sign-up/index.vue")
  },
  {
    name: "sign-up___fr",
    path: "/fr/sign-up",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/sign-up/index.vue")
  },
  {
    name: "sign-up___it",
    path: "/it/sign-up",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/sign-up/index.vue")
  },
  {
    name: "sign-up___de",
    path: "/de/sign-up",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/sign-up/index.vue")
  },
  {
    name: "sign-up___hy",
    path: "/hy/sign-up",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/sign-up/index.vue")
  },
  {
    name: "sign-up___ru",
    path: "/ru/sign-up",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/sign-up/index.vue")
  },
  {
    name: "all___en",
    path: "/:all(.*)*",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/[...all]/index.vue")
  },
  {
    name: "all___fr",
    path: "/fr/:all(.*)*",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/[...all]/index.vue")
  },
  {
    name: "all___it",
    path: "/it/:all(.*)*",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/[...all]/index.vue")
  },
  {
    name: "all___de",
    path: "/de/:all(.*)*",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/[...all]/index.vue")
  },
  {
    name: "all___hy",
    path: "/hy/:all(.*)*",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/[...all]/index.vue")
  },
  {
    name: "all___ru",
    path: "/ru/:all(.*)*",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/[...all]/index.vue")
  },
  {
    name: "branches___en",
    path: "/branches",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/branches/index.vue")
  },
  {
    name: "branches___fr",
    path: "/fr/branches",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/branches/index.vue")
  },
  {
    name: "branches___it",
    path: "/it/branches",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/branches/index.vue")
  },
  {
    name: "branches___de",
    path: "/de/branches",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/branches/index.vue")
  },
  {
    name: "branches___hy",
    path: "/hy/branches",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/branches/index.vue")
  },
  {
    name: "branches___ru",
    path: "/ru/branches",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/branches/index.vue")
  },
  {
    name: "checkout___en",
    path: "/checkout",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/checkout/index.vue")
  },
  {
    name: "checkout___fr",
    path: "/fr/checkout",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/checkout/index.vue")
  },
  {
    name: "checkout___it",
    path: "/it/checkout",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/checkout/index.vue")
  },
  {
    name: "checkout___de",
    path: "/de/checkout",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/checkout/index.vue")
  },
  {
    name: "checkout___hy",
    path: "/hy/checkout",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/checkout/index.vue")
  },
  {
    name: "checkout___ru",
    path: "/ru/checkout",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/checkout/index.vue")
  },
  {
    name: "delivery___en",
    path: "/delivery",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/delivery/index.vue")
  },
  {
    name: "delivery___fr",
    path: "/fr/delivery",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/delivery/index.vue")
  },
  {
    name: "delivery___it",
    path: "/it/delivery",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/delivery/index.vue")
  },
  {
    name: "delivery___de",
    path: "/de/delivery",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/delivery/index.vue")
  },
  {
    name: "delivery___hy",
    path: "/hy/delivery",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/delivery/index.vue")
  },
  {
    name: "delivery___ru",
    path: "/ru/delivery",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/delivery/index.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___fr",
    path: "/fr/privacy-policy",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___it",
    path: "/it/privacy-policy",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___de",
    path: "/de/privacy-policy",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___hy",
    path: "/hy/privacy-policy",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ru",
    path: "/ru/privacy-policy",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/privacy-policy.vue")
  },
  {
    name: "categories___en",
    path: "/categories",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/categories/index.vue")
  },
  {
    name: "categories___fr",
    path: "/fr/categories",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/categories/index.vue")
  },
  {
    name: "categories___it",
    path: "/it/categories",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/categories/index.vue")
  },
  {
    name: "categories___de",
    path: "/de/categories",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/categories/index.vue")
  },
  {
    name: "categories___hy",
    path: "/hy/categories",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/categories/index.vue")
  },
  {
    name: "categories___ru",
    path: "/ru/categories",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/categories/index.vue")
  },
  {
    name: "fulfillment___en",
    path: "/fulfillment",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/fulfillment/index.vue")
  },
  {
    name: "fulfillment___fr",
    path: "/fr/fulfillment",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/fulfillment/index.vue")
  },
  {
    name: "fulfillment___it",
    path: "/it/fulfillment",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/fulfillment/index.vue")
  },
  {
    name: "fulfillment___de",
    path: "/de/fulfillment",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/fulfillment/index.vue")
  },
  {
    name: "fulfillment___hy",
    path: "/hy/fulfillment",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/fulfillment/index.vue")
  },
  {
    name: "fulfillment___ru",
    path: "/ru/fulfillment",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/fulfillment/index.vue")
  },
  {
    name: "privacy-legal___en",
    path: "/privacy-legal",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/privacy-legal/index.vue")
  },
  {
    name: "privacy-legal___fr",
    path: "/fr/privacy-legal",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/privacy-legal/index.vue")
  },
  {
    name: "privacy-legal___it",
    path: "/it/privacy-legal",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/privacy-legal/index.vue")
  },
  {
    name: "privacy-legal___de",
    path: "/de/privacy-legal",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/privacy-legal/index.vue")
  },
  {
    name: "privacy-legal___hy",
    path: "/hy/privacy-legal",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/privacy-legal/index.vue")
  },
  {
    name: "privacy-legal___ru",
    path: "/ru/privacy-legal",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/privacy-legal/index.vue")
  },
  {
    name: "reset-password___en",
    path: "/reset-password",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/reset-password/index.vue")
  },
  {
    name: "reset-password___fr",
    path: "/fr/reset-password",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/reset-password/index.vue")
  },
  {
    name: "reset-password___it",
    path: "/it/reset-password",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/reset-password/index.vue")
  },
  {
    name: "reset-password___de",
    path: "/de/reset-password",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/reset-password/index.vue")
  },
  {
    name: "reset-password___hy",
    path: "/hy/reset-password",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/reset-password/index.vue")
  },
  {
    name: "reset-password___ru",
    path: "/ru/reset-password",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/reset-password/index.vue")
  },
  {
    name: "orders-orderId___en",
    path: "/orders/:orderId()",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/orders/[orderId]/index.vue")
  },
  {
    name: "orders-orderId___fr",
    path: "/fr/orders/:orderId()",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/orders/[orderId]/index.vue")
  },
  {
    name: "orders-orderId___it",
    path: "/it/orders/:orderId()",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/orders/[orderId]/index.vue")
  },
  {
    name: "orders-orderId___de",
    path: "/de/orders/:orderId()",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/orders/[orderId]/index.vue")
  },
  {
    name: "orders-orderId___hy",
    path: "/hy/orders/:orderId()",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/orders/[orderId]/index.vue")
  },
  {
    name: "orders-orderId___ru",
    path: "/ru/orders/:orderId()",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/orders/[orderId]/index.vue")
  },
  {
    name: "categories-slug___en",
    path: "/categories/:slug()",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/categories/[slug]/index.vue")
  },
  {
    name: "categories-slug___fr",
    path: "/fr/categories/:slug()",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/categories/[slug]/index.vue")
  },
  {
    name: "categories-slug___it",
    path: "/it/categories/:slug()",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/categories/[slug]/index.vue")
  },
  {
    name: "categories-slug___de",
    path: "/de/categories/:slug()",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/categories/[slug]/index.vue")
  },
  {
    name: "categories-slug___hy",
    path: "/hy/categories/:slug()",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/categories/[slug]/index.vue")
  },
  {
    name: "categories-slug___ru",
    path: "/ru/categories/:slug()",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/categories/[slug]/index.vue")
  },
  {
    name: "checkout-PaymentsFailedModal___en",
    path: "/checkout/PaymentsFailedModal",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/checkout/PaymentsFailedModal.vue")
  },
  {
    name: "checkout-PaymentsFailedModal___fr",
    path: "/fr/checkout/PaymentsFailedModal",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/checkout/PaymentsFailedModal.vue")
  },
  {
    name: "checkout-PaymentsFailedModal___it",
    path: "/it/checkout/PaymentsFailedModal",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/checkout/PaymentsFailedModal.vue")
  },
  {
    name: "checkout-PaymentsFailedModal___de",
    path: "/de/checkout/PaymentsFailedModal",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/checkout/PaymentsFailedModal.vue")
  },
  {
    name: "checkout-PaymentsFailedModal___hy",
    path: "/hy/checkout/PaymentsFailedModal",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/checkout/PaymentsFailedModal.vue")
  },
  {
    name: "checkout-PaymentsFailedModal___ru",
    path: "/ru/checkout/PaymentsFailedModal",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/checkout/PaymentsFailedModal.vue")
  },
  {
    name: "checkout-PaymentsSuccessedModal___en",
    path: "/checkout/PaymentsSuccessedModal",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/checkout/PaymentsSuccessedModal.vue")
  },
  {
    name: "checkout-PaymentsSuccessedModal___fr",
    path: "/fr/checkout/PaymentsSuccessedModal",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/checkout/PaymentsSuccessedModal.vue")
  },
  {
    name: "checkout-PaymentsSuccessedModal___it",
    path: "/it/checkout/PaymentsSuccessedModal",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/checkout/PaymentsSuccessedModal.vue")
  },
  {
    name: "checkout-PaymentsSuccessedModal___de",
    path: "/de/checkout/PaymentsSuccessedModal",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/checkout/PaymentsSuccessedModal.vue")
  },
  {
    name: "checkout-PaymentsSuccessedModal___hy",
    path: "/hy/checkout/PaymentsSuccessedModal",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/checkout/PaymentsSuccessedModal.vue")
  },
  {
    name: "checkout-PaymentsSuccessedModal___ru",
    path: "/ru/checkout/PaymentsSuccessedModal",
    component: () => import("/var/www/scan.ova-restaurant.com/pages/checkout/PaymentsSuccessedModal.vue")
  }
]